module.exports = __webpack_public_path__ + "static/media/Cooked_Kelp_Fronds.960cb94a.webp";